/**
 * hooks/useLead.js
 * Управление данными лида: сохранение полей и отправка.
 */
import { useCallback } from 'react';
import { useWidget } from '@/state/WidgetContext';
import { leadsService } from '@/services/leads';

export function useLead() {
  const { state, setLeadField } = useWidget();
  const { user } = state;

  const setName    = useCallback((v) => setLeadField('name',    v), [setLeadField]);
  const setCompany = useCallback((v) => setLeadField('company', v), [setLeadField]);
  const setEmail   = useCallback((v) => setLeadField('email',   v), [setLeadField]);
  const setPhone   = useCallback((v) => setLeadField('phone',   v), [setLeadField]);
  const setQuestion= useCallback((v) => setLeadField('question',v), [setLeadField]);
  const setMessage = useCallback((v) => setLeadField('message', v), [setLeadField]);

  /**
   * Отправить лид на сервер.
   * @param {object} extraFields — дополнительные поля (например, { guide_requested: true })
   * @returns {Promise<boolean>} true при успехе, false при ошибке
   */
  const submitLead = useCallback(async (extraFields = {}) => {
    try {
      await leadsService.createLead(user, extraFields);
      return true;
    } catch (err) {
      console.error('[useLead] submitLead error:', err);
      return false;
    }
  }, [user]);

  return {
    leadData: user.leadData,
    setName,
    setCompany,
    setEmail,
    setPhone,
    setQuestion,
    setMessage,
    submitLead,
  };
}